import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest } from '../../../components/utils/api';

export default class YoutubeConnect extends Component {
	constructor(props) {
		super(props);
	}

	getAuthUrl() {
		apiGetRequest("users/get-authorization-url/").then((data) => {
			console.log(data);
			if (data.url) {
				window.location.href = data.url
			}
		})
	}

	render() {
		return (
			<div class={cx("home")}>
                <div class={cx("content-container")}>
                    <div style={{textAlign: 'center'}}>
                        <h1 class={cx("headline")}>Hey {this.props.userProfile.first_name}</h1>
                        <p cx={"subheading"}>Click below to connect your Youtube Channel</p>
                    </div>
                    
                    <button class={cx("button")} onClick={() => this.getAuthUrl()}>
                        <p>Connect Youtube Account</p>
                    </button>
                </div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./routes/teams/youtubeConnect/index.js